/**
 * @generated SignedSource<<a30a6f62aaf0cf59efd26d824a7bd5c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueComment_issueComment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueCommentEditor_repository" | "IssueCommentViewerCommentRow">;
  readonly " $fragmentType": "IssueComment_issueComment";
};
export type IssueComment_issueComment$key = {
  readonly " $data"?: IssueComment_issueComment$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueComment_issueComment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueComment_issueComment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssueCommentViewerCommentRow"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssueCommentEditor_repository"
    }
  ],
  "type": "IssueComment",
  "abstractKey": null
};

(node as any).hash = "43f3b74852476aa24690e8cc1c4d8101";

export default node;
